import React, { useState, useEffect, useContext } from 'react';

import { useNavigate, Link, Navigate } from 'react-router-dom';

import { Header, Footer, HeaderBox } from '../components/imports'

import { WEBROOT, APP_NAME, PHOTOS_ROOT } from '../constants/general'

import { Text } from '../constants/Text'

import { Context } from '../class/Context'

import Func from '../class/Func'

import Annonces from '../class/Annonces';

import Paiements_Class from '../class/Paiements_Class'

const publier = async (e, setError, navigate) => {

    e.preventDefault()

    let inputs = e.target

    const results = await Annonces.publier(inputs)

    if (results.success) {

        Func.setFlash(results.message)

        navigate('/mon-profile/articles')

    } else {

        setError(results.message)

        window.scrollTo(0, 0)

    }

}

const uploadPhotos = (e, setError, setPhotos, photos, setLoading) => {

    let files = e.target.files

    //let newPhotosUrls = []

    if (files.length <= 6) {

        //setPhotos(files)

        Array.from(files).forEach(photo => {

            upload(photo, setPhotos, photos, setError, setLoading)

            //newPhotosUrls.push(URL.createObjectURL(photo))

        })

        //setPhotosUrls(newPhotosUrls)

    } else {

        setError(Text.nombre_de_photos)

        e.target.files = null

    }

}

const upload = async (file, setPhotos, photos, setError, setLoading) => {

    if (file.size == 0 || file.name == null) setError("Impossible d'ajouter cette photo une erreur est survenu.")

    setLoading(true)

    let results = await Annonces.photoUpload(file)

    setLoading(false)

    if (results.success) {

        // if(photos == undefined){
        //     photos = []
        // }

        // let new_element = photos
        // new_element.push(results.data)

        // setPhotos([])

        // setInterval(function(){
        //     setPhotos(new_element)
        // }, 1000)

        getImages(setPhotos)

    } else {

        setError(results.message)

    }

}

const getImages = async (setPhotos) => {

    let results = await Annonces.getPhotosPublier()

    setPhotos(results.data)

}

const uploadPhotosInput = () => {

    document.querySelector('#uploadPhotosInput').click()

}

const supprimerPhoto = async (e, id) => {

    let t = e.target.parentNode

    t.style.opacity = 0.5

    let results = await Annonces.supprimerPhoto(id)

    if (results.success) {

        t.style.display = 'none'

    } else {

        alert(results.message)

    }

}

function Vendre() {

    const navigate = useNavigate()

    const context = useContext(Context)

    const [loading, setLoading] = useState(false)

    const [error, setError] = useState('')

    const [photos, setPhotos] = useState([])
    const [photosUrls, setPhotosUrls] = useState([])

    const [categorie, setCategorie] = useState(1)

    const [mode_envoi, setModeEnvoi] = useState('colis')
    const [type_envoi, setTypeEnvoi] = useState('poste')
    const [poids, setPoids] = useState('250')
    const [poidExacte, setPoidExacte] = useState(0)
    const [tarifEnvoi, setTarifEnvoi] = useState(0)

    const [vendre, setVendre] = useState(false)

    const change_mode_envoi = (e) => {

        setModeEnvoi(e.target.value)

        if (e.target.value == 'colis' && poids < 250) setPoids('250')

        if (e.target.value == 'enveloppe' && poids > 2000) setPoids('2000')

        if (e.target.value == 'enveloppe') setTypeEnvoi('poste')

        setPoidExacteFunc(poidExacte, e.target.value)

    }

    const noWheel = (e) => {

        e.target.blur()

        e.stopPropagation()

        setTimeout(() => {
            e.target.focus()
        }, 0)

    }

    const setPoidExacteFunc = (val, this_mode_envoi) => {

        setPoidExacte(val)

        if (this_mode_envoi == 'enveloppe') {

            if (val <= 20) setTarifEnvoi(1.85)
            if (val > 20 && val <= 100) setTarifEnvoi(3.20)
            if (val > 100 && val <= 250) setTarifEnvoi(5.21)
            if (val > 250 && val <= 500) setTarifEnvoi(7.05)
            if (val > 500 && val <= 1000) setTarifEnvoi(8.80)
            if (val > 1000 && val <= 2000) setTarifEnvoi(10.55)

        }

        if (this_mode_envoi == 'colis') {

            if (val <= 250) setTarifEnvoi(5.25)
            if (val > 250 && val <= 500) setTarifEnvoi(7.35)
            if (val > 500 && val <= 750) setTarifEnvoi(8.65)
            if (val > 750 && val <= 1000) setTarifEnvoi(9.40)
            if (val > 1000 && val <= 2000) setTarifEnvoi(10.70)
            if (val > 2000 && val <= 5000) setTarifEnvoi(16.60)

        }

        // if (this_mode_envoi == 'mondial_relay') {

        //     if (val <= 250) setTarifEnvoi(4.20)
        //     if (val > 250 && val <= 500) setTarifEnvoi(4.40)
        //     if (val > 500 && val <= 1000) setTarifEnvoi(5.40)
        //     if (val > 1000 && val <= 2000) setTarifEnvoi(6.60)
        //     if (val > 2000 && val <= 3000) setTarifEnvoi(7.50)
        //     if (val > 3000 && val <= 4000) setTarifEnvoi(8.80)
        //     if (val > 4000 && val <= 5000) setTarifEnvoi(12.40)
        //     if (val > 5000 && val <= 7000) setTarifEnvoi(14.40)
        //     if (val > 7000 && val <= 10000) setTarifEnvoi(14.40)
        //     if (val > 10000 && val <= 15000) setTarifEnvoi(22.41)
        //     if (val > 15000 && val <= 20000) setTarifEnvoi(22.41)
        //     if (val > 20000 && val <= 25000) setTarifEnvoi(32.40)
        //     if (val > 25000 && val <= 30000) setTarifEnvoi(32.40)

        // }

    }

    const userPaiements = async () => {

        let results = await Paiements_Class.paiements()

        if (results.success) {

            if (results.account_verified != true) {

                navigate('/mon-profile/porte-monnaie')

                return false

            } else {

                setVendre(true)

                setTimeout(() => {

                    Func.choixSelect('#taille ._choix')

                    Func.choixSelect('#poids_colis ._choix')

                    Func.choixSelect('#mode_envoi ._choix')

                    Func.choixSelect('#type_envoi ._choix')

                }, 1000);

            }

        }

    }

    useEffect(() => {

        // Func.session(context, navigate, '/connexion', true)

        if ((context.session !== true)) navigate('/connexion')

        document.title = "Vendre - " + APP_NAME

        document.body.classList.remove('mn')

        userPaiements()

        // Func.choixSelect('#taille ._choix')

        // Func.choixSelect('#poids_colis ._choix')

        // Func.choixSelect('#mode_envoi ._choix')

        // Func.choixSelect('#type_envoi ._choix')

        getImages(setPhotos)

    }, [])

    return (
        <div className="">

            <Header />

            <HeaderBox />

            <div className='content pos-r'>

                {

                    vendre

                        ?

                        <div className="c">

                            <span className='cl2 textUnd fz09'>Vends ton article</span>

                            {(error !== '') && <p className="error">{error}</p>}

                            <form method="POST" className="gla-form" encType='multipart/form-data' onSubmit={(e) => publier(e, setError, navigate)}>

                                <div className="bg7 br8 p20 mt20 ta-center">

                                    <div className="col-9 m0a">


                                        {

                                            loading

                                                ?

                                                <div className='flex jc-center mt50 mb50'>
                                                    <div className="lds-dual-ring col"></div>
                                                </div>

                                                :

                                                <span className="btn brc3 brc1solid cl1 bg3 ta-center mb10 col-3 textUp" onClick={(e) => uploadPhotosInput()}>Ajouter des photos</span>

                                        }

                                        <span className='d-block'>Ajoute jusqu’à 6 photos.</span>

                                        <Link to={'/page/astuces'} className='cl3 textUnd'>Voir astuces</Link>

                                        <input type="file" name='uploadPhotosInput' id='uploadPhotosInput' accept='image/*' multiple maxLength='6' onChange={e => uploadPhotos(e, setError, setPhotos, photos, setLoading)} className="d-none" />

                                    </div>

                                    {

                                        photos

                                        &&

                                        <div className='flex m_flex m_f_wrap jc-center m0a pt20 vender_img'>

                                            {

                                                photos.map(image =>

                                                    <div key={image.idI} style={{ width: '100px', margin: '10px' }}>
                                                        <img src={PHOTOS_ROOT + 'small/' + image.name + '.jpg'} style={{ width: '100px', height: '100px', marginBottom: '10px', borderRadius: '5px', objectFit: 'cover' }} />
                                                        <span className='btn cl3 icon' onClick={(e) => supprimerPhoto(e, image.idI)}>w</span>
                                                    </div>

                                                )

                                            }

                                        </div>

                                    }


                                    {photosUrls.map(image =>

                                        <div key={image.idI} style={{ width: '100px', margin: '10px' }}>
                                            <img src={image} style={{ width: '100px', height: '100px', margin: '10px', borderRadius: '5px', objectFit: 'cover' }} />
                                        </div>

                                    )

                                    }

                                </div>

                                <div className="bg7 br8 p20 mt20 ta-center">

                                    <div className="col-9 m0a">
                                        <label>
                                            <span>Catégorie</span>

                                            <select id='categorie' name='categorie' onChange={e => setCategorie(e.target.value)}>
                                                <option value="1">Plantes</option>
                                                <option value="2">Accessoires</option>
                                                <option value="3">Pots</option>
                                                <option value="4">Livres</option>
                                                <option value="5">Engraits et autres</option>
                                            </select>
                                        </label>

                                        {

                                            categorie == 1

                                            &&

                                            <label>
                                                <span>Type de plantes</span>

                                                <select id='type' name='type'>
                                                    <option value="1">Plantes vertes</option>
                                                    <option value="2">Plantes rares</option>
                                                    <option value="6">Plantes aromatiques</option>
                                                    <option value="3">Plantes grasses</option>
                                                    <option value="4">Plantes fleuries</option>
                                                    <option value="7">Graines et Bulbes</option>
                                                    <option value="5">Autres</option>
                                                </select>
                                            </label>

                                        }

                                        {

                                            categorie == 2

                                            &&

                                            <label>
                                                <span>Type d'accessoires</span>

                                                <select id='type' name='type'>
                                                    <option value="1">Arrosoirs</option>
                                                    <option value="2">Tuteurs</option>
                                                    <option value="3">Oyas</option>
                                                    <option value="4">Autres</option>
                                                </select>
                                            </label>

                                        }

                                        {

                                            categorie == 3

                                            &&

                                            <label>
                                                <span>Type de pots</span>

                                                <select id='type' name='type'>
                                                    <option value="1">Terre cuite</option>
                                                    <option value="2">Plastique</option>
                                                    <option value="3">Ceramique</option>
                                                    <option value="4">Autres</option>
                                                </select>
                                            </label>

                                        }

                                        {

                                            categorie == 4

                                            &&

                                            <label>
                                                <span>Type de livres</span>

                                                <select id='type' name='type'>
                                                    <option value="1">Botanique</option>
                                                    <option value="2">Potager</option>
                                                    <option value="3">Arbres</option>
                                                    <option value="4">Herboristerie</option>
                                                    <option value="5">Autres</option>
                                                </select>
                                            </label>

                                        }

                                        {

                                            categorie == 5

                                            &&

                                            <select id='type' name='type' style={{ display: 'none' }}>
                                                <option value="1" selected>autre</option>
                                            </select>

                                        }

                                        <label>
                                            <span>Titre</span>
                                            <input type="text" name="titre" placeholder="ex : Alocasia Zebrina" rows="1" required={true} />
                                        </label>

                                        <label>
                                            <span>Description</span>
                                            <textarea name="description" placeholder="ex : Alocasia de taille moyenne (45 cm)  qui aime la lumière…" required={true}></textarea>
                                        </label>

                                        <label className='mb0'>
                                            <span>Prix (€)</span>
                                            <input type="number" name="prix" placeholder="0,00€" step='0.01' required={true} min={2} onWheel={e => noWheel(e)} />
                                        </label>

                                    </div>

                                </div>

                                <div className="bg7 br8 p20 mt20">

                                    <div className="col-9 m0a">

                                        <div className='label m_d_block'>
                                            <label><span>Taille</span></label>
                                            <div className="flex col-65 m_col_10 m_mt_20 jc-start m_flex m_f_wrap" id='taille'>

                                                <div className='ta-center mr30 _choix' style={{ display: categorie == 1 ? 'block' : 'none' }}>
                                                    <span className="opt bg2 h ta-center icon bg3">x</span>
                                                    <p className='fz09'>Graine</p>
                                                    <input type='radio' value='Gr' name='taille' defaultChecked />
                                                </div>

                                                <div className='ta-center mr30 _choix'>
                                                    <span className="opt bg2 h ta-center">S</span>
                                                    <p className='fz09'>5-30 cm</p>
                                                    <input type='radio' value='S' name='taille' />
                                                </div>

                                                <div className='ta-center mr30 _choix'>
                                                    <span className="opt bg2 h ta-center">M</span>
                                                    <p className='fz09'>30-60 cm</p>
                                                    <input type='radio' value='M' name='taille' />
                                                </div>

                                                <div className='ta-center mr30 _choix'>
                                                    <span className="opt bg2 h ta-center">L</span>
                                                    <p className='fz09'>60-90 cm</p>
                                                    <input type='radio' value='L' name='taille' />
                                                </div>

                                                <div className='ta-center mr30 _choix'>
                                                    <span className="opt bg2 h ta-center">XL</span>
                                                    <p className='fz09'>90-130 cm</p>
                                                    <input type='radio' value='XL' name='taille' />
                                                </div>

                                            </div>
                                        </div>

                                        <label className='mb0'>
                                            <span>Conseils d’entretien ( optionnel ) : </span>
                                            <textarea name="conseils" placeholder="ex : Parfaite pour sublimer votre salle de bain !"></textarea>
                                        </label>

                                    </div>

                                </div>

                                <div className="bg7 br8 p20 mt20">

                                    <div className="col-9 m0a">

                                        <div className='label'>

                                            <div className='col-3'>
                                                <label><span className='mb10 d-block'>Mode d'expédition</span></label>

                                                {

                                                    mode_envoi == 'colis'

                                                    &&

                                                    <p className='fz07 m_d_none'>Favorise ta boite aux lettre et l’acheteur pourra aussi récupérer son colis en point relais. (À condition que ta plante soit d’accord), <Link to={'/page/colis-boite-aux-lettres'} className='cl3' target='_blank'>Voir conditions</Link></p>

                                                }

                                            </div>

                                            <div className='col-65 flex jc-start m_col_10 m_mt_20'>

                                                <div className="col-3" id='mode_envoi'>

                                                    {/* <div className='ta-center _choix flex m_flex jc-start mb20 m_col_10 m_mb_40'>
                                                        <span className="opt bg11 h ta-center mini bg3 mr10"></span>
                                                        <img src={'/image/lettre_suivie.webp'} style={{ height: '18px' }} />
                                                        <input type='radio' value='enveloppe' name='mode_envoi' checked={mode_envoi == 'enveloppe'} onChange={change_mode_envoi} />
                                                    </div> */}

                                                    {/* <div className='ta-center _choix flex m_flex jc-start mb20 m_col_10 m_mb_40'>
                                                        <span className="opt bg11 h ta-center mini mr10"></span>
                                                        <img src={'/image/mondial_relay.webp'} style={{ height: '18px' }} />
                                                        <input type='radio' value='mondial_relay' name='mode_envoi' checked={mode_envoi == 'mondial_relay'} onChange={change_mode_envoi} />
                                                    </div> */}

                                                    <div className='ta-center _choix flex m_flex jc-start m_col_10 ai-center'>
                                                        <span className="opt bg11 h ta-center mini mr10 bg3"></span>
                                                        <img src={'/image/colissimo.webp'} style={{ height: '24px', marginBottom: '10px' }} />
                                                        <input type='radio' value='colis' name='mode_envoi' checked={mode_envoi == 'colis'} onChange={change_mode_envoi} />
                                                    </div>

                                                </div>

                                                {

                                                    mode_envoi == 'colis'

                                                    &&

                                                    <p className='fz07 mt10 d-none m_d_block'>Favorise ta boite aux lettre et l’acheteur pourra aussi récupérer son colis en point relais. (À condition que ta plante soit d’accord), <Link to={'/page/colis-boite-aux-lettres'} className='cl3' target='_blank'>Voir conditions</Link></p>

                                                }

                                                <div className="flex col-4 m_flex m_mt_10 m_col_3" id='type_envoi' style={{ paddingTop: '7px' }}>

                                                    <div className='ta-center mr30 _choix' style={{ display: mode_envoi == 'colis' ? 'block' : 'none' }}>
                                                        <span className={`opt bg11 h ta-center mini ${type_envoi == 'poste' && 'bg3'}`}></span>
                                                        <p className='fz08'>Bureau de poste</p>
                                                        <input type='radio' value='poste' name='type_envoi' checked={type_envoi == 'poste'} onChange={e => setTypeEnvoi(e.target.value)} />
                                                    </div>

                                                    <div className='ta-center mr30 _choix' style={{ display: mode_envoi == 'colis' ? 'block' : 'none' }}>
                                                        <span className={`opt bg11 h ta-center mini ${type_envoi == 'boite' && 'bg3'}`}></span>
                                                        <p className='fz08'>Boite aux lettres</p>
                                                        <input type='radio' value='boite' name='type_envoi' checked={type_envoi == 'boite'} onChange={e => setTypeEnvoi(e.target.value)} />
                                                    </div>

                                                </div>

                                            </div>
                                        </div>

                                    </div>

                                </div>

                                <div className="bg7 br8 p20 mt20">

                                    <div className="col-9 m0a">

                                        <div>

                                            <label className='mb0'>

                                                <div>
                                                    <span>Poids exact de l'article (g)</span>
                                                    <p className='fz08'>Poids maximum autorisé pour l’envoi {mode_envoi == 'enveloppe' ? 2 : mode_envoi == 'colis' ? 5 : 30} kg</p>
                                                </div>

                                                <input type="number" name="poids" placeholder="Ex : 120 g" defaultValue={poidExacte > 0 ? poidExacte : ''} required={true} onChange={e => setPoidExacteFunc(e.target.value, mode_envoi)} max={mode_envoi == 'enveloppe' ? 2000 : mode_envoi == 'colis' ? 5000 : 30000} />

                                            </label>

                                        </div>

                                    </div>

                                    {/* { (mode_envoi == 'enveloppe' || mode_envoi == 'colis') &&

                                <div className="col-9 m0a m_mt_40">

                                    <div className='label'>

                                        <label><span>Poids de l’enveloppe/colis</span></label>

                                        <div className="flex col-65 jc-start fz09 m_col_10 m_flex m_f_wrap m_mt_20" id='poids_colis'>

                                            <div className='ta-center mr30 _choix' style={{ display: mode_envoi == 'enveloppe' ? 'block' : 'none' }}>
                                                <p className='fz09 mb10'>{mode_envoi == 'enveloppe' ? "1.85 €" : "0"}</p>
                                                <span className={`opt bg11 h ta-center mini ${poids == '20' && 'bg3'}`}></span>
                                                <p className='fz09 fw6'>Max 20 g</p>
                                                <input type='radio' value='20' name='poids_colis' checked={poids == '20'} onChange={e => setPoids(e.target.value)} />
                                            </div>

                                            <div className='ta-center mr30 _choix' style={{ display: mode_envoi == 'enveloppe' ? 'block' : 'none' }}>
                                                <p className='fz09 mb10'>{mode_envoi == 'enveloppe' ? "3.20 €" : "0"}</p>
                                                <span className={`opt bg11 h ta-center mini ${poids == '100' && 'bg3'}`}></span>
                                                <p className='fz09 fw6'>Max 100 g</p>
                                                <input type='radio' value='100' name='poids_colis' checked={poids == '100'} onChange={e => setPoids(e.target.value)} />
                                            </div>

                                            <div className='ta-center mr30 _choix'>
                                                <p className='fz09 mb10'>{mode_envoi == 'enveloppe' ? "5.21 €" : "5.25 €"}</p>
                                                <span className={`opt bg11 h ta-center mini ${poids == '250' && 'bg3'}`}></span>
                                                <p className='fz09 fw6'>Max 250 g</p>
                                                <input type='radio' value='250' name='poids_colis' checked={poids == '250'} onChange={e => setPoids(e.target.value)} />
                                            </div>

                                            <div className={`ta-center mr30 _choix ${mode_envoi == 'enveloppe' ? '' : ''}`}>
                                                <p className='fz09 mb10'>{mode_envoi == 'enveloppe' ? "7.05 €" : "7.35 €"}</p>
                                                <span className={`opt bg11 h ta-center mini ${poids == '500' && 'bg3'}`}></span>
                                                <p className='fz09 fw6'>Max 500 g</p>
                                                <input type='radio' value='500' name='poids_colis' checked={poids == '500'} onChange={e => setPoids(e.target.value)} />
                                            </div>

                                            <div className='ta-center mr30 _choix' style={{ display: mode_envoi == 'colis' ? 'block' : 'none' }}>
                                                <p className='fz09 mb10'>{mode_envoi == 'enveloppe' ? "0" : "8.65 €"}</p>
                                                <span className={`opt bg11 h ta-center mini ${poids == '750' && 'bg3'}`}></span>
                                                <p className='fz09 fw6'>Max 750 g</p>
                                                <input type='radio' value='750' name='poids_colis' checked={poids == '750'} onChange={e => setPoids(e.target.value)} />
                                            </div>

                                            <div className='ta-center mr30 _choix'>
                                                <p className='fz09 mb10'>{mode_envoi == 'enveloppe' ? "8.80 €" : "9.40 €"}</p>
                                                <span className={`opt bg11 h ta-center mini ${poids == '1000' && 'bg3'}`}></span>
                                                <p className='fz09 fw6'>Max 1 kg</p>
                                                <input type='radio' value='1000' name='poids_colis' checked={poids == '1000'} onChange={e => setPoids(e.target.value)} />
                                            </div>

                                            <div className='ta-center mr30 _choix'>
                                                <p className='fz09 mb10'>{mode_envoi == 'enveloppe' ? "10.55 €" : "10.70 €"}</p>
                                                <span className={`opt bg11 h ta-center mini ${poids == '2000' && 'bg3'}`}></span>
                                                <p className='fz09 fw6'>Max 2 kg</p>
                                                <input type='radio' value='2000' name='poids_colis' checked={poids == '2000'} onChange={e => setPoids(e.target.value)} />
                                            </div>

                                            <div className='ta-center mr30 _choix' style={{ display: mode_envoi == 'colis' ? 'block' : 'none' }}>
                                                <p className='fz09 mb10'>{mode_envoi == 'enveloppe' ? "0" : "16.60 €"}</p>
                                                <span className={`opt bg11 h ta-center mini ${poids == '5000' && 'bg3'}`}></span>
                                                <p className='fz09 fw6'>Max 5 kg</p>
                                                <input type='radio' value='5000' name='poids_colis' checked={poids == '5000'} onChange={e => setPoids(e.target.value)} />
                                            </div>

                                        </div>
                                    </div>

                                </div>

                            }

                            { mode_envoi == 'mondial_relay' &&
                                
                                <div className="col-9 m0a m_mt_40">

                                    <div className='label'>

                                        <label><span>Poids de l’enveloppe/colis</span></label>

                                        <div className="flex col-65 jc-start fz09 m_col_10 m_flex m_f_wrap m_mt_20" id='poids_colis'>

                                            <div className='ta-center mr30 _choix'>
                                                <p className='fz09 mb10'>3.49 €</p>
                                                <span className={`opt bg11 h ta-center mini ${poids == '250' && 'bg3'}`}></span>
                                                <p className='fz09 fw6'>Max 250 g</p>
                                                <input type='radio' value='250' name='poids_colis' checked={poids == '250'} onChange={e => setPoids(e.target.value)} />
                                            </div>

                                            <div className={`ta-center mr30 _choix ${mode_envoi == 'enveloppe' ? '' : ''}`}>
                                                <p className='fz09 mb10'>3.58 €</p>
                                                <span className={`opt bg11 h ta-center mini ${poids == '500' && 'bg3'}`}></span>
                                                <p className='fz09 fw6'>Max 500 g</p>
                                                <input type='radio' value='500' name='poids_colis' checked={poids == '500'} onChange={e => setPoids(e.target.value)} />
                                            </div>

                                            <div className='ta-center mr30 _choix'>
                                                <p className='fz09 mb10'>4.49 €</p>
                                                <span className={`opt bg11 h ta-center mini ${poids == '1000' && 'bg3'}`}></span>
                                                <p className='fz09 fw6'>Max 1 kg</p>
                                                <input type='radio' value='1000' name='poids_colis' checked={poids == '1000'} onChange={e => setPoids(e.target.value)} />
                                            </div>

                                            <div className='ta-center mr30 _choix'>
                                                <p className='fz09 mb10'>5.49 €</p>
                                                <span className={`opt bg11 h ta-center mini ${poids == '2000' && 'bg3'}`}></span>
                                                <p className='fz09 fw6'>Max 2 kg</p>
                                                <input type='radio' value='2000' name='poids_colis' checked={poids == '2000'} onChange={e => setPoids(e.target.value)} />
                                            </div>

                                            <div className='ta-center mr30 _choix'>
                                                <p className='fz09 mb10'>6.17 €</p>
                                                <span className={`opt bg11 h ta-center mini ${poids == '3000' && 'bg3'}`}></span>
                                                <p className='fz09 fw6'>Max 3 kg</p>
                                                <input type='radio' value='3000' name='poids_colis' checked={poids == '3000'} onChange={e => setPoids(e.target.value)} />
                                            </div>

                                            <div className='ta-center mr30 _choix'>
                                                <p className='fz09 mb10'>7.42 €</p>
                                                <span className={`opt bg11 h ta-center mini ${poids == '4000' && 'bg3'}`}></span>
                                                <p className='fz09 fw6'>Max 4 kg</p>
                                                <input type='radio' value='4000' name='poids_colis' checked={poids == '4000'} onChange={e => setPoids(e.target.value)} />
                                            </div>

                                        </div>

                                        <div className="flex col-65 jc-start fz09 m_col_10 m_flex m_f_wrap m_mt_20" id='poids_colis'>

                                            <div className='ta-center mr30 _choix'>
                                                <p className='fz09 mb10'>10.33 €</p>
                                                <span className={`opt bg11 h ta-center mini ${poids == '5000' && 'bg3'}`}></span>
                                                <p className='fz09 fw6'>Max 5 kg</p>
                                                <input type='radio' value='5000' name='poids_colis' checked={poids == '5000'} onChange={e => setPoids(e.target.value)} />
                                            </div>

                                            <div className='ta-center mr30 _choix'>
                                                <p className='fz09 mb10'>12.00 €</p>
                                                <span className={`opt bg11 h ta-center mini ${poids == '7000' && 'bg3'}`}></span>
                                                <p className='fz09 fw6'>Max 7 kg</p>
                                                <input type='radio' value='7000' name='poids_colis' checked={poids == '7000'} onChange={e => setPoids(e.target.value)} />
                                            </div>

                                            <div className='ta-center mr30 _choix'>
                                                <p className='fz09 mb10'>12.00 €</p>
                                                <span className={`opt bg11 h ta-center mini ${poids == '10000' && 'bg3'}`}></span>
                                                <p className='fz09 fw6'>Max 10 kg</p>
                                                <input type='radio' value='10000' name='poids_colis' checked={poids == '10000'} onChange={e => setPoids(e.target.value)} />
                                            </div>

                                            <div className='ta-center mr30 _choix'>
                                                <p className='fz09 mb10'>18.67 €</p>
                                                <span className={`opt bg11 h ta-center mini ${poids == '15000' && 'bg3'}`}></span>
                                                <p className='fz09 fw6'>Max 15 kg</p>
                                                <input type='radio' value='15000' name='poids_colis' checked={poids == '15000'} onChange={e => setPoids(e.target.value)} />
                                            </div>

                                            <div className='ta-center mr30 _choix'>
                                                <p className='fz09 mb10'>18.67 €</p>
                                                <span className={`opt bg11 h ta-center mini ${poids == '20000' && 'bg3'}`}></span>
                                                <p className='fz09 fw6'>Max 20 kg</p>
                                                <input type='radio' value='20000' name='poids_colis' checked={poids == '20000'} onChange={e => setPoids(e.target.value)} />
                                            </div>

                                            <div className='ta-center mr30 _choix'>
                                                <p className='fz09 mb10'>27.00 €</p>
                                                <span className={`opt bg11 h ta-center mini ${poids == '25000' && 'bg3'}`}></span>
                                                <p className='fz09 fw6'>Max 25 kg</p>
                                                <input type='radio' value='25000' name='poids_colis' checked={poids == '25000'} onChange={e => setPoids(e.target.value)} />
                                            </div>

                                            <div className='ta-center mr30 _choix'>
                                                <p className='fz09 mb10'>27.00 €</p>
                                                <span className={`opt bg11 h ta-center mini ${poids == '30000' && 'bg3'}`}></span>
                                                <p className='fz09 fw6'>Max 30 kg</p>
                                                <input type='radio' value='30000' name='poids_colis' checked={poids == '30000'} onChange={e => setPoids(e.target.value)} />
                                            </div>

                                        </div>
                                    </div>

                                </div>

                            } */}

                                </div>

                                <div className="bg7 br8 p20 mt20">

                                    <div className="col-9 m0a">

                                        <div>

                                            <label className='mb0'>

                                                <div>
                                                    <span>Tarif envoi (€)</span>
                                                </div>

                                                <p className='col-65 fw6 pl10'>{tarifEnvoi} €</p>

                                            </label>

                                        </div>

                                    </div>

                                </div>

                                <div className="ta-end mt10 pb20">
                                    <input type="submit" name="submit" value="Publier" className="btn bg3 cl5 brc3 brc1solid" />
                                </div>

                            </form>

                        </div>

                        :

                        <div className="c pb40">


                            <div className='flex jc-center mt50 mb50'>
                                <div className="lds-dual-ring col"></div>
                            </div>


                        </div>

                }

                <Footer />

            </div>

        </div>
    )

}

export default Vendre